<template>
  <div>
    <!--account settings-->
    <div class="settings__account--profile">
      <div class="panel">
        <div class="panel__header">
          <div class="panel__header__left">
            User
            <span>Accounts</span>
          </div>
          <div class="panel__header__right">
            <button class="btn btn--primary btn--flex" data-toggle="modal" data-target="#newUser" v-if="enableActions">+ Add User</button>
          </div>
        </div>
        <div class="panel__content panel__content--grey">
          <div class="parent-container">
            <div class="table table--special-width transfer__table">
              <div class="table__section table__section--body">
                <!-- table row -->
                <div class="table__row" v-for="(u, key) in users" :key="key">
                  <!-- table data -->
                  <div class="table__data table__data--bold" style="width: 15%">
                    <div class="table__data--bold">
                      <div class="table__data--default"> {{ momentDate(u.createdAt) }} </div>
                      <div class="table__data--sub">Sign up Date</div>
                    </div>
                  </div>
                  <!-- table data -->
                  <div class="table__data table__data--bold" style="width: 15%">
                    <div class="table__data--bold">
                      <div class="table__data--default">{{ u.name || 'No Name' }}</div>
                      <div class="table__data--sub">Name</div>
                    </div>
                  </div>
                  <!-- table data -->
                  <div class="table__data">
                    <div class="table__data--result">{{ u.email }}</div>
                    <div class="table__data--sub">Email</div>
                  </div>
                  <!-- table data -->
                  <div class="table__data">
                    <div class="table__data--default">{{ u.role || 'User' }}</div>
                    <div class="table__data--sub">
                      <span>Role</span>
                      <span
                        v-if="Object.keys(u.permission).length"
                      >+ {{ Object.keys(u.permission).length }} Permissions</span>
                    </div>
                  </div>
                  <!-- table data -->
                    <div class="table__data">
                      <div class="table__data--default">
                        <span v-if="u.ban == 1" class="tag" :class="['tag--reversed']">Blocked</span>
                        <span v-else class="tag" :class="['tag--completed']">Active</span>
                      </div>
                    </div>
                  <!-- table data -->
                  <div class="table__data">
                    <button class="btn btn-primary" @click="editUser(key)" data-toggle="modal" data-target="#viewUser" v-if="enableActions">View</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <div class="panel__footer align-end">
          <div class="panel__footer__right">
            <button class="btn btn--default">Cancel</button>
            <button class="btn btn--primary">Save changes</button>
          </div>
        </div>-->
      </div>
    </div>

    <div
      class="modal fade"
      id="viewUser"
      tabindex="-1"
      role="dialog"
      aria-labelledby="viewUser"
    >
      <!-- Modal Dialog -->
      <div class="modal__dialog modal__dialog--lg" role="document">
        <!-- Modal content -->
        <div class="modal__content">
           <div class="modal__header">
            <div class="modal__title">
              View User
            </div>
            <!-- Modal close button -->
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                <path
                  fill="#C0C6D8"
                  fill-rule="nonzero"
                  d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z"
                ></path>
              </svg>
            </button>
          </div>
          <!-- Modal Body -->
          <div class="modal__body modal__body--pad--mini">
            <div class v-if="newuserF.edit">
              <form action class="form disburse-form" @submit.prevent="editUser()">

                <div class="form__item">
                  <label for="useremail" class="form__label--span form--left">
                    User <span>Email</span>
                  </label>
                  <div class="select form--right">
                    <input
                      type="text"
                      name="useremail"
                      placeholder
                      v-model="user.email"
                      class="form__input input"
                      data-vv-id="1"
                      aria-required="true"
                      aria-invalid="false"
                      disabled
                    >
                  </div>
                </div>

                <div class="form__item">
                  <label for="useremail" class="form__label--span form--left">
                    User <span>Name</span>
                  </label>
                  <div class="select form--right">
                    <input
                      type="text"
                      name="username"
                      placeholder
                      v-model="user.name"
                      class="form__input input"
                      data-vv-id="1"
                      aria-required="true"
                      aria-invalid="false"
                      disabled
                    >
                  </div>
                </div>

                <div class="form__item">
                  <label class="form__label--span form--left">
                    User <span>Role</span>
                  </label>
                  <div class="select">
                    <div><input type="radio" id="User" value="User" v-model="user.role"> &nbsp; <label for="User"> User</label></div>
                    <div><input type="radio" id="Approver" value="Approver" v-model="user.role"> &nbsp; <label for="Approver"> Approver</label></div>
                    <div><input type="radio" id="Administrator" value="Administrator" v-model="user.role"> &nbsp; <label for="Administrator"> Adminstrator</label></div>
                  </div>
                </div>
                <div class="form__item">
                    <label class="form__label--span form--left">
                      Account <span>Owner</span>
                    </label>
                    <div class="select">
                      <div><input type="checkbox" id="user" value="user" v-model="user.activeowner"></div>
                    </div>
                  </div>
                  <div>
                    <small> Note: Account Owner receives all authorization emails. </small>
                  </div>
                  <br>
                <div class="">
                  <button
                    type="submit"
                    class="btn btn--primary beneficiary_submit"
                  >Update</button>
                    <button
                      v-if="userEmail !== user.email"
                      style="float: right;"
                      id="deleteUser"
                      type="submit"
                      class="btn btn--default beneficiary_submit"
                      data-dismiss="modal" aria-label="Close"
                      @click="deleteUser()"
                    >Delete</button>
                  </div>


                <!-- <div class="form__item">
                  <label class="form__label--span form--left">
                    User <span>Permission</span>
                  </label>
                  <div class="select">
                    <div><input type="checkbox" id="user" value="user" v-model="user.role"> &nbsp; <label for="user"> Approver Level B</label></div>
                    <div><input type="checkbox" id="approver" value="approver" v-model="user.role"> &nbsp; <label for="approver">User Management</label></div>
                    <div><input type="checkbox" id="admin" value="admin" v-model="user.role"> &nbsp; <label for="admin">Balance Management</label></div>
                  </div>
                </div> -->

                <br>

                <!-- <div class="form__item">
                  <button
                    type="submit"
                    class="btn btn--primary btn--block beneficiary_submit"
                    data-dismis="modal"
                    aria-label="Close"
                    data-toggle="modal"
                    data-target="#viewUser"
                  >Update</button>
                </div> -->
              </form>
            </div>
            <div class="disburse__result text-center" v-if="!newuserF.edit">
              <div v-if="newuserF.fail">
                  <div class="result-img">
                    <svg
                      enable-background="new 0 0 50 50"
                      version="1.1"
                      viewBox="0 0 50 50"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon--custom-big"
                    >
                    <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                      <polyline
                        points="16 34 25 25 34 16"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                      <polyline
                        points="16 16 25 25 34 34"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                  </svg>
                  </div>
                  <p v-for="error in newuserF.error" class="disburse__result__error error-text">{{error}}</p>
                  <button
                    class="btn btn--primary"
                    @click="utilities().retryAddUser()"
                  >Retry</button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div
      class="modal fade"
      id="newUser"
      tabindex="-1"
      role="dialog"
      aria-labelledby="newUser"
    >
      <div class="modal__dialog modal__dialog--lg" role="document">
          <!-- Modal content -->
          <div class="modal__content">
            <div class="modal__header">
              <div class="modal__title">
                Add User
              </div>
              <!-- Modal close button -->
              <button id="closeNewUser" type="button" class="close" data-dismiss="modal" aria-label="Close">
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13">
                  <path
                    fill="#C0C6D8"
                    fill-rule="nonzero"
                    d="M8.254 6.5l4.383-4.382A1.24 1.24 0 0 0 10.882.363L6.5 4.746 2.118.363A1.24 1.24 0 1 0 .363 2.118L4.746 6.5.363 10.882a1.24 1.24 0 0 0 1.755 1.755L6.5 8.254l4.382 4.383a1.24 1.24 0 1 0 1.755-1.755L8.254 6.5z"
                  ></path>
                </svg>
              </button>
            </div>
            <!-- Modal Body -->
            <div class="modal__body modal__body--pad--mini">
              <div class v-if="newuserF.edit">
                <form action class="form disburse-form" @submit.prevent="newUser()">

                  <div class="form__item">
                    <label for="useremail" class="form__label--span form--left">
                      User <span>Email</span>
                    </label>
                    <div class="select form--right">
                      <input
                        type="text"
                        name="useremail"
                        placeholder
                        v-model="newuser.useremail"
                        class="form__input input"
                        data-vv-id="1"
                        aria-required="true"
                        aria-invalid="false"
                        v-validate="'required'"
                      >
                    </div>
                  </div>
                  <transition name="slide-fade">
                    <div class="form__input--error--text" v-if="errors.has('useremail')">
                      <p>{{ errors.first('useremail') }}</p>
                    </div>
                  </transition>

                  <div class="form__item">
                    <label for="useremail" class="form__label--span form--left">
                      User <span>Name</span>
                    </label>
                    <div class="select form--right">
                      <input
                        type="text"
                        name="fullname"
                        placeholder
                        v-model="newuser.fullname"
                        class="form__input input"
                        data-vv-id="1"
                        aria-required="true"
                        aria-invalid="false"
                        v-validate="'required'"
                      >
                    </div>
                  </div>
                  <transition name="slide-fade">
                    <div class="form__input--error--text" v-if="errors.has('fullname')">
                      <p>{{ errors.first('fullname') }}</p>
                    </div>
                  </transition>

                  <div class="form__item">
                    <label class="form__label--span form--left">
                      User <span>Role</span>
                    </label>
                    <div class="select">
                      <div><label><input type="radio" id="user" value="User" v-model="newuser.role"> &nbsp; User</label></div>
                      <div><label><input type="radio" id="approver" value="Approver" v-model="newuser.role"> &nbsp; Approver</label></div>
                      <div><label><input type="radio" id="Administrator" value="Administrator" v-model="newuser.role"> &nbsp; Adminstrator</label></div>
                    </div>
                  </div>

                  <div class="form__item">
                    <label class="form__label--span form--left">
                      Primary <span>User</span>
                    </label>
                    <div class="select">
                      <div><input type="checkbox" id="user" value="user" v-model="newuser.activeowner"></div>
                    </div>
                  </div>
                  <div>
                    <label> Note: Making user primary account will make other accounts not primary </label>
                  </div>


                  <!-- <div class="form__item">
                    <label class="form__label--span form--left">
                      User <span>Permission</span>
                    </label>
                    <div class="select">
                      <div><input type="checkbox" id="user" value="user" v-model="user.role"> &nbsp; <label for="user"> Approver Level B</label></div>
                      <div><input type="checkbox" id="approver" value="approver" v-model="user.role"> &nbsp; <label for="approver">User Management</label></div>
                      <div><input type="checkbox" id="admin" value="admin" v-model="user.role"> &nbsp; <label for="admin">Balance Management</label></div>
                    </div>
                  </div> -->

                  <br>

                  <div class="form__item">
                    <!-- data-dismis="modal"
                    aria-label="Close"
                    data-toggle="modal"
                    data-target="#newUser" -->
                    <button
                      type="submit"
                      class="btn btn--primary btn--block beneficiary_submit"

                    >Create</button>
                  </div>
                </form>
              </div>

              <div class="disburse__result text-center" v-if="!newuserF.edit">
                <div v-if="newuserF.pass">
                  <!--success icon-->
                  <div class="result-img">
                    <svg
                      class="icon icon--custom-big"
                      enable-background="new 0 0 50 50"
                      version="1.1"
                      viewBox="0 0 50 50"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                    <circle cx="25" cy="25" r="25" fill="#25AE88"></circle>
                      <polyline
                        points="38 15 22 33 12 25"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                  </svg>
                  </div>
                  <p class="disburse__result__success success-text">User Added successfully!</p>
                  <button
                    class="btn btn--primary"
                    @click="utilities().resetAddUser()"
                  >Add Another User</button>
                  <button
                    class="btn btn--default"
                    @click="utilities().pageReload()"
                  >See All Users</button>
                </div>

                <div v-if="newuserF.fail">
                  <div class="result-img">
                    <svg
                      enable-background="new 0 0 50 50"
                      version="1.1"
                      viewBox="0 0 50 50"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon--custom-big"
                    >
                    <circle cx="25" cy="25" r="25" fill="#D75A4A"></circle>
                      <polyline
                        points="16 34 25 25 34 16"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                      <polyline
                        points="16 16 25 25 34 34"
                        fill="none"
                        stroke="#fff"
                        stroke-linecap="round"
                        stroke-miterlimit="10"
                        stroke-width="2"
                      ></polyline>
                  </svg>
                  </div>
                  <p v-for="error in newuserF.error" class="disburse__result__error error-text">{{error}}</p>
                  <button
                    class="btn btn--primary"
                    @click="utilities().retryAddUser()"
                  >Retry</button>
                </div>
              </div>
            </div>
          </div>
      </div>



    </div>
  </div>
</template>

<script>
import moment from "moment";
import { getTeam, saveUser, deleteUser, editUser } from "../../utils/user/getUserDetails";
export default {
  data() {
    return {
      users: {},
      user: {},
      newuser: {},
      key: null,
      userEmail: this.$cookies.get('userEmail'),
      newuserF: {
        edit: true,
        pass: false,
        fail: false,
        error: [],
      }
    };
  },

  created() {
    this.teamUsers();
  },

  components: {},
  computed: {
    enableActions: {
      get() {
        return this.$store.state.enableActions;
      },
    },
  },
  methods: {
    momentDate(date) {
            return moment(date).format('MMM Do, YYYY')
        },
    editUser(key) {
      if (key) this.key = key;

      const u = {
        name: this.users[this.key].name,
        email: this.users[this.key].email,
        permission: this.users[this.key].permission,
      };
      if (key) {
        u.role = this.users[this.key].role || 'User';
        u.activeowner = this.users[this.key].activeowner || 0;
      } else {
        u.role = this.user.role;
        u.activeowner = this.user.activeowner;
      }
      this.user = u;

      console.log(key, this.key, this.user);

      if (!key) {
        editUser(this.key, this.user.role, this.user.activeowner).then((resp) => {
          this.teamUsers();
          $("#viewUser").modal("hide");
          // this.newuserF.edit = false;
          this.$Progress.finish();
        })
        .catch((err) => {
          if(err.response && err.response.data) {
            const e = err.response.data;
            this.newuserF.error.push(e.message);
            this.utilities().errorAddUser();
          }
        })
      }
    },

    deleteUser(){
      const self = this;
      let email = self.user.email;
      console.log(self.user);
      this.$Progress.start();
      deleteUser(email).then((response) => {
        console.log(response);
        this.teamUsers();
        self.$Progress.finish();
      })
      .catch((error) => {
        console.log(error);
        self.$Progress.fail();
      });
    },

    newUser() {
      const self = this;
      this.$validator.validateAll().then(result => {
        if (result) {
          saveUser(this.newuser).then((resp) => {
            // $("#closeNewUser").click();
            self.utilities().passAddUser();
          }).catch((err) => {
            if(err.response && err.response.data) {
              const e = err.response.data;
              this.newuserF.error.push(e.message);
              self.utilities().errorAddUser();
            }
          })
        }
      });

    },

    teamUsers() {
      getTeam().then(resp => {
        if (resp.status === 200) {
          console.log(resp.data);
          this.users = resp.data;
        }
      }).catch(err => {
        console.log(err);
      });
    },

    utilities() {
      const self = this;
      return {
        retryAddUser() {
          self.newuserF.edit = true;
          self.newuserF.pass = false;
          self.newuserF.fail = false;
          self.newuserF.error = [];
        },
        errorAddUser() {
          self.newuserF.edit = false;
          self.newuserF.pass = false;
          self.newuserF.fail = true;
        },
        passAddUser() {
          self.newuserF.edit = false;
          self.newuserF.pass = true;
          self.newuserF.fail = false;
        },
        resetAddUser() {
          self.newuser = {};
          self.newuserF.edit = true;
          self.newuserF.pass = false;
          self.newuserF.fail = false;
        },
        pageReload() {
          // self.$router.push('/balance/funding-history');
          location.reload();
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.panel__footer__right {
  .btn--default {
    margin-right: 8px;
  }
}
.select__icon {
  top: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/TeamSettings.vue